import '@styles/components/appCiviStationconStru.less';

const AppCivilStationConstru = () => {
  return (
    <div className={'app-display-desc'}>
      <div>
        <div className={'content-introduction'}>
          建造大师 CivilStation Construction（简称CSC）是跨世纪基于云技术、GIS
          技术、大数据技术与物联网技术（IoT）于一体自主研发的BIM综合管理平台。施工集成管理系统是 CSC
          面向建造阶段的管理板块，主要服务于基础设施领域各参建方，通过构建多项目集成平台，将标段做为管理单元，BIM
          作为数据载体及分析对象，以进度为纽带，以投资成本为核心，以质量为抓手，以安全为底线，使项目管理过程从平面转向立体、静态转向动态、封闭转向协同共享，实现工程项目的集成管理和数字化协同。
        </div>
        <img className={'bimw'} src={require('@images/home/jzds_01.png').default} alt="" />
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <p className={'text'}>产品定位</p>
          <span className={'line'} />
        </div>
        <div className={'csc-text'}>平台总体构架</div>
        <div className={'introduce'}>
          采用先进的GIS引擎及BIM平台，搭建自主开发体系，突破单一二维平台构架，依托自主图形引擎数字孪生云平台BIM
          Windows（简称BW），先进GIS引擎、工作流引擎KSJ BMPE及表单引擎 KSJ
          FME，云计算等基础能力，构建基础设施全生命期项目管理协同平台，业务范围覆盖项目前期规划管理和施工集成管理两部分。
        </div>
        <div className={'text-center'}>
          <img className={'csc'} src={require('@images/home/csc01.jpg').default} alt="" />
          {/* <p className={'qldsimgj'}>桥梁大师界面及导出CSD功能</p> */}
        </div>
        <div className={'csc-text'}>面向多领域、多专业的项目管理</div>
        <div className={'introduce'}>
          CSC施工集成管理系统板块已覆盖多个行业，包含市政、公路、铁路、水利等基础设施领域，针对各行业设计特点做适应性开发，以满足基础设施项目管理需求。
        </div>
        <div className={'text-center'}>
          <div className={'img_list'}>
            <img className={'csclist'} src={require('@images/home/csc_01.png').default} alt="" />
            <p className={'qldsimgj'}>铁路项目</p>
          </div>
          <div className={'img_list'}>
            <img className={'csclist'} src={require('@images/home/csc_02.png').default} alt="" />
            <p className={'qldsimgj'}>水利水电项目</p>
          </div>
          <div className={'img_list'}>
            <img className={'csclist'} src={require('@images/home/csc_03.png').default} alt="" />
            <p className={'qldsimgj'}>市政项目</p>
          </div>
          <div className={'img_list'}>
            <img className={'csclist'} src={require('@images/home/csc_04.png').default} alt="" />
            <p className={'qldsimgj'}>公路项目</p>
          </div>
          <div className={'clear'}></div>
        </div>
        <div className={'csc-text'}>面向建设单位全过程管理</div>
        <div className={'introduce'}>
          CSC建设单位项目管理子板块系统针对建设管理22项核心业务，146项细分业务，聚焦甲方进度、投资、合同等主控方向，借助跨世纪自研工作流引擎、表单库引擎，先进的业务处理方法，可有效改善管理效率实现管理流程数字化。
        </div>
        <div className={'csc-text'}>面向施工单位精细化管理</div>
        <div className={'introduce'}>
          采用传统管理方法在施工阶段易发生部门间协同效率低，现场管理标准化不足，形象进度上报滞后，收入成本控制缺乏时效，项目索赔证据不足，积累数据利用率不高等问题，CSC施工总包项目管理子系统（项目布）板块，面向施工总承包单位，针对12项核心业务，80项细分业务，以BIM为载体，以标准为依据，以时间为纽带，智能算法为工具，横向串联项目部门间业务，纵向贯通企业多项目经营，实现风险智能监控、业务实时办理，主材消耗及时预警，进度智能跟踪，变更索赔机会挖掘、收支智能分析的全面项目施工数字化。
        </div>
        <div className={'csc-text'}>面向生产智能建造</div>
        <div className={'introduce'}>
          CSC智慧梁场板块采用BW图形引擎及先进的排产算法，通过跨世纪自主研发正向设BIM设计软件设计大师CivilStation
          Designer（简称CSD）快速完成桥梁及梁场三维设计，一键导入智慧梁场平台，自动编码、协同绑码、自动排产等一系列准备工作，即可开展项目架梁、存梁、制梁的二三维一体化管理，有效发挥生产架设协同能力，以较低的投入，高效的管理实现大型预制构件从建造到架设的全流程数字化管理。
          <div className={'text-center'}>
            <img className={'csc'} src={require('@images/home/csc_05.png').default} alt="" />
            <p className={'qldsimgj'}>管理流程及功能</p>
          </div>
        </div>
        <div className={'csc-text'}>面向细分领域专项管理</div>
        <div className={'introduce'}>
          针对路面铺筑作业面分散、日均材料消耗大、施工机械投入密集、摊铺及碾压质量要求高、施工组织协调难度大等特点，结合BIM+GIS优势，总结生产经验，以施工日报为数据入口结合材料类型配置、站点配置、合同清单分解、进度计划编制，基于BIM平台自动完成产值统计、构件完成统计、路面进度对比、形象进度图等功能，为项目协同管理提供决策支撑。
          <div className={'text-center'}>
            <img className={'csc'} src={require('@images/home/csc_06.png').default} alt="" />
            <p className={'qldsimgj'}>路面施工进度对比</p>
          </div>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <span className={'text'}>产品优势</span>
          <span className={'line'} />
        </div>
        <div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>无纸化办公协同管理体系，提升建设单位项目管理效能</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>WBS-EBS-BQS 一体化，驱动管理行为贯通联动</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>
              内置公路、市政清单标准、检验批质量验评标准，提高数据载入及标准利用率
            </span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>多算对比，辅助工程算量，提升成本核算精度。</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>基于BIM模型智能分析与展示，辅助工程项目安全技术监控</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>企业BI大数据统计与分析</span>
          </div>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/csc.gif').default} alt="" />
          {/* <p className={'qldsimgj'}>围岩变形</p> */}
        </div>
      </div>
    </div>
  );
};

export default AppCivilStationConstru;
